module.exports = __webpack_public_path__ + "static/img/contact_title1.ee92653.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cec2022/contact_title1.png
// module id = QU8k
// module chunks = 4